import * as Common from "../../commons/common"

export class SheetField{
  id: number
  kind: number
  page: number
  part1: string
  part2: string
  part3: string
  allot: number
  rim: number[]
  view_point_id: number
  color: string
  colorCache: string = null

  get name(): string{
    let rtn = "";
    if(this.kind == Common.SheetFieldKindEnum.TOTAL_SCORE){
      rtn = "得点";
    }else if(this.kind == Common.SheetFieldKindEnum.STUDENT_INFO){
      rtn = "生徒情報";
    }else if(this.kind == Common.SheetFieldKindEnum.STUDENT_KEY_RECOG){
      rtn = `出席番号`;
    }else if(this.kind == Common.SheetFieldKindEnum.PART1){
      rtn = `大問${this.part1}`;
    }else{
      if(this.part1 != null){
        rtn += this.part1;
      }
      if(this.part2 != null){
        rtn += ` ${this.part2}`
      }
      if(this.part3 != null){
        rtn += ` ${this.part3}`
      }
    }
    return rtn;
  }

  constructor(sheet_field: any){
    this.id = sheet_field.id;
    this.kind = sheet_field.kind;
    this.page = sheet_field.page;
    this.part1 = sheet_field.part1;
    this.part2 = sheet_field.part2;
    this.part3 = sheet_field.part3;
    this.allot = sheet_field.allot;
    this.rim = sheet_field.rim;
    this.view_point_id = sheet_field.view_point_id;
    this.color = sheet_field.color ? sheet_field.color : "#ff0000";
  }
}

export class SheetFieldMark {
  id: number
  x: number
  y: number
  width: number
  height: number
  color: string
  part1: string
  part2: string
  part3: string
  is_disp: boolean
  page: number
  view_point_id: number

  get name(): string{
    let rtn = "";
    if(this.part1){
      rtn += this.part1;
    }
    if(this.part2){
      rtn += ` ${this.part2}`
    }
    if(this.part3){
      rtn += ` ${this.part3}`
    }
    return rtn;
  }

  constructor(x: any){
    this.id = x.id;
    this.x = x.x;
    this.y = x.y;
    this.width = x.width;
    this.height = x.height;
    this.color = x.color;
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.is_disp = x.is_disp;
    this.page = x.page;
    this.view_point_id = x.view_point_id;
  }
}


export class FieldItem{
  sheetField: SheetField | null = null
  sheetFieldMark: SheetFieldMark | null = null
  key: number = 0
  sortNo: number = 0
  x: number = 0
  y: number = 0
  width: number = 0
  height: number = 0
  isActive: boolean = false
  pageNo: number
  fieldType: number
  isDraggable: boolean = false
  isResizable: boolean = false
  isSelectable: boolean = false
  allotText: AllotText = null
}

export class CorrectHoseiPosition {
  id: number
  base_sheet_id: number
  page: number
  pos_no: number
  rim: number[]
  pos_name: string

  constructor(correct_hosei_position: any, baseWidth: number, baseHeight: number){
    this.id = correct_hosei_position.id;
    this.base_sheet_id = correct_hosei_position.base_sheet_id;
    this.page = correct_hosei_position.page;
    this.pos_no = correct_hosei_position.pos_no;

    if(this.pos_no == 1){
      this.pos_name = "左上";
    }else if(this.pos_no == 2){
      this.pos_name = "左下";
    }else if(this.pos_no == 3){
      this.pos_name = "右下";
    }else if(this.pos_no == 4){
      this.pos_name = "右上";
    }

    if(correct_hosei_position.rim != null){
      this.rim = correct_hosei_position.rim;
    }else{
      const margin = 80;
      if(this.pos_no == 1){
        this.rim = [margin, margin];
      }else if(this.pos_no == 2){
        this.rim = [margin, baseHeight - margin];
      }else if(this.pos_no == 3){
        this.rim = [baseWidth - margin, baseHeight - margin];
      }else if(this.pos_no == 4){
        this.rim = [baseWidth - margin, margin];
      }
    }
  }
}


export class PageItem{
  pageNo: number
  base64Image: string
  baseWidth: number
  baseHeight: number
  fieldItems: FieldItem[] = new Array<FieldItem>()
  correct_hosei_positions: CorrectHoseiPosition[] = []
  // sheetFieldMarks: SheetFieldMark[] = new Array<SheetFieldMark>();

  constructor(pageNo: number, base64Image: string, baseWidth: number, baseHeight: number, correct_hosei_positions: any[]){
    this.pageNo = pageNo;
    this.baseWidth = baseWidth;
    this.baseHeight = baseHeight;
    this.base64Image = base64Image;
    this.correct_hosei_positions = correct_hosei_positions.filter((x: any) => x.page == pageNo).map((x: any) => new CorrectHoseiPosition(x, baseWidth, baseHeight));
  }
}

export class Pos {
  x: number
  y: number

  constructor(x: number, y: number){
    this.x = x;
    this.y = y;
  }
}

export class AllotText {
  x: number
  y: number
  width: number
  height: number
  text: string
  font_size: number
  line_height: number = 0
  color: string
  font_family: string
  base64Image: string
  direction: number
}